import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { DataTablesModule } from 'angular-datatables';
import { HighchartsChartModule } from 'highcharts-angular';
import { BaseChartDirective } from 'ng2-charts';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../../../shared/shared.module';
import { EnitComplainceRoutingModule } from '../eComplaince-routing.module';
import { EnitRoutingModule } from '../eTrade-routing.module';
import { TradeAdminRoutingModule } from '../tradeAdmin-routing.module';
import { AutomationModule } from './Automation/automation.module';
import { ColoModule } from './Colo/colo.module';
import { CtclModule } from './ctcl/ctcl.module';
import { DisableNeatUserIdAdminComponent } from './disable-neat-user-id-admin/disable-neat-user-id-admin.component';
import { DisableNeatUserIdComponent } from './disable-neat-user-id/disable-neat-user-id.component';
import { DisplayAlgoUndertakingDetailsComponent } from './display-algo-undertaking-details/display-algo-undertaking-details.component';
import { DualModule } from './Dual Locking/dual.module';
import { EnitMisReportComponent } from './enitmis-report/enit-mis-report.component';
import { EtChangeNameProcessPageComponent } from './et-change-name-process-page/et-change-name-process-page.component';
import { EtMessageRateAdminModalComponent } from './et-message-rate-admin-modal/et-message-rate-admin-modal.component';
import { EtMesssageRateAdminComponent } from './et-messsage-rate-admin/et-messsage-rate-admin.component';
import { EtNeatToNonneatComponent } from './et-neat-to-nonneat/et-neat-to-nonneat.component';
import { EtNewneatRequestProcessPageComponent } from './et-newneat-request-process-page/et-newneat-request-process-page.component';
import { EtUseridRequestListComponent } from './et-userid-request-list/et-userid-request-list.component';
import { EtmMessageRateChangeReportComponent } from './etm-message-rate-change-report/etm-message-rate-change-report.component';
import { EtmMessageRateModalComponent } from './etm-message-rate-modal/etm-message-rate-modal.component';
import { EtmMessageRateUserIdRequestComponent } from './etm-message-rate-user-id-request/etm-message-rate-user-id-request.component';
import { EtmNeatUserNameChangeRequestComponent } from './etm-neat-user-name-change-request/etm-neat-user-name-change-request.component';
import { EtmNewneatUseridRequestComponent } from './etm-newneat-userid-request/etm-newneat-userid-request.component';
import { IpSurrenderModule } from './ip-surrender/ip-surrender.module';
import { LesModule } from './LES/les.module';
import { LoadAlgoApprovalComponent } from './load-algo-approval/load-algo-approval.component';
import { MultiLockingModule } from './multiple-locking-removal/multi-locking.module';
import { NeatNonneatProcessPageAdminComponent } from './neat-nonneat-process-page-admin/neat-nonneat-process-page-admin.component';
import { NeatNonneatProcesspageComponent } from './neat-nonneat-processpage/neat-nonneat-processpage.component';
import { NeatNonneatReportAdminComponent } from './neat-nonneat-report-admin/neat-nonneat-report-admin.component';
import { NeatNonneatReportComponent } from './neat-nonneat-report/neat-nonneat-report.component';
import { NeatUserValidityUpdationModalComponent } from './neat-user-validity-updation-modal/neat-user-validity-updation-modal.component';
import { NeatUserValidityUpdationComponent } from './neat-user-validity-updation/neat-user-validity-updation.component';
import { NnfModule } from './NNF/nnf.module';
import { OtpModule } from './otp.module';
import { PasswordOrUnlockRequestAdminComponent } from './password-or-unlock-request-admin/password-or-unlock-request-admin.component';
import { PasswordOrUnlockRequestComponent } from './password-or-unlock-request/password-or-unlock-request.component';
import { ProEnablementModule } from './pro-enablement/pro-enablement.module';
import { ShiftingNeatIdAdminRequestComponent } from './shifting-neat-id-admin-request/shifting-neat-id-admin-request.component';
import { ShiftingNeatIdRequestComponent } from './shifting-neat-id-request/shifting-neat-id-request.component';
import { UnlockResetModalComponent } from './unlock-reset-modal/unlock-reset-modal.component';
import { UserIpMappingComponent } from './user-ip-mapping/user-ip-mapping.component';
import { WorkPremitModule } from './work-permit-module/work-permit.module';






@NgModule({
  declarations: [
 
    DisableNeatUserIdComponent,
    DisableNeatUserIdAdminComponent,
    DisplayAlgoUndertakingDetailsComponent,
    EnitMisReportComponent,
    EtChangeNameProcessPageComponent,
    EtMessageRateAdminModalComponent,
    EtMesssageRateAdminComponent,
    EtNeatToNonneatComponent,
    EtNewneatRequestProcessPageComponent,
    EtUseridRequestListComponent,
    EtmMessageRateChangeReportComponent,
    EtmMessageRateModalComponent,
    EtmMessageRateUserIdRequestComponent,
    EtmNeatUserNameChangeRequestComponent,
    EtmNewneatUseridRequestComponent,
    LoadAlgoApprovalComponent,
    NeatNonneatProcessPageAdminComponent,
    NeatNonneatProcesspageComponent,
    NeatNonneatReportComponent,
    NeatNonneatReportAdminComponent,
    NeatUserValidityUpdationComponent,
    NeatUserValidityUpdationModalComponent,
    PasswordOrUnlockRequestComponent,
    PasswordOrUnlockRequestAdminComponent,
    ShiftingNeatIdAdminRequestComponent,
    ShiftingNeatIdRequestComponent,
    UnlockResetModalComponent,
    UserIpMappingComponent,


  ],
  imports: [
    
    CommonModule,
    EnitRoutingModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule,
    AutomationModule,
    ColoModule,
    CtclModule,
    DualModule,
    IpSurrenderModule,
    LesModule,
    MultiLockingModule,
    NnfModule,
    ProEnablementModule,
    WorkPremitModule,
    OtpModule
  ]
})
export class EnitTradeModule { }
